import { get } from "@src/appV2/api/api";
import { API_TYPES } from "@src/appV2/api/constants";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import {
  useMutation,
  type UseMutationOptions,
  type UseMutationResult,
} from "@tanstack/react-query";
import { type AxiosError } from "axios";
import { z } from "zod";

const distributionUrlSchema = z.object({
  data: z.object({
    attributes: z.object({
      distributionUrl: z.string(),
    }),
    id: z.string(),
    type: z.literal(API_TYPES.distributionUrl),
  }),
});

export type DocumentDistributionUrlResponse = z.infer<typeof distributionUrlSchema>;

export function useDocumentDistributionUrl(
  options: UseMutationOptions<DocumentDistributionUrlResponse, AxiosError, string> = {}
): UseMutationResult<DocumentDistributionUrlResponse, AxiosError, string> {
  return useMutation({
    mutationFn: async (documentId: string) => {
      const response = await get({
        url: `${environmentConfig.REACT_APP_DOCUMENTS_SERVICE_REST_API_URL}/documents/${documentId}/distribution-url`,
        responseSchema: distributionUrlSchema,
      });
      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_DISTRIBUTION_URL_FAILURE,
    },
    ...options,
  });
}
